import React, { useRef, useMemo } from 'react';

import contextGenerator, { nameSpaces } from 'utils/contextGenerator';

import DialogInfoBeforeLoginTrigger from 'client/components/infoDialog/DialogInfoBeforeLoginTrigger';
import DialogInfoAfterLoginTrigger from 'client/components/infoDialog/DialogInfoAfterLoginTrigger';
import DialogQualifyCheckTrigger from 'client/components/infoDialog/DialogQualifyCheckTrigger';

const { Provider, useContextValue } = contextGenerator(nameSpaces.CLIENT_PROMO_JOIN_CHECKER, {
    login: () => {},
    full: () => {}
});

export const useCheckerContext = useContextValue;

export const checkTypes = {
    LOGIN_STATUS: 'LOGIN_STATUS',
    PROMO_STATUS: 'PROMO_STATUS',
    QUALIFY_STATUS: 'QUALIFY_STATUS'
};

export default function ProviderFlowInfoAndActionChecker({ children }) {
    const infoBeforeLogin = useRef(null);
    const infoAfterLogin = useRef(null);
    const infoInterAction = useRef(null);
    const checkers = useMemo(
        () => ({
            // types 是可以設定要檢查哪幾個 dialog
            check: (types = [], shouldOpen = true) => {
                const checkTypesMappingCheckers = {
                    [checkTypes.LOGIN_STATUS]: infoBeforeLogin,
                    [checkTypes.PROMO_STATUS]: infoAfterLogin,
                    [checkTypes.QUALIFY_STATUS]: infoInterAction
                };
                return runner(
                    types.map(t => checkTypesMappingCheckers[t].current).filter(Boolean),
                    shouldOpen
                );
            }
        }),
        []
    );

    return (
        <>
            <DialogInfoBeforeLoginTrigger ref={infoBeforeLogin} />
            <DialogInfoAfterLoginTrigger ref={infoAfterLogin} />
            <DialogQualifyCheckTrigger ref={infoInterAction} />
            <Provider value={checkers}>{children}</Provider>
        </>
    );
}

// instance 是 [infoBeforeLogin, infoAfterLogin, infoInterAction] 這個 ref of array
// 若全部 instance 都
function runner(instances = [], shouldOpen) {
    for (const i of instances) {
        if (Boolean(i) && typeof i.checkIsHasInfo === 'function') {
            // 如果這個 ref 在條件上是沒有 dialog Info，checkApi 會回傳 false
            if (i.checkIsHasInfo(shouldOpen)) {
                // 因為 dialog 需要被顯示，代表 checkApi 要通知呼叫的人要先處理好 dialog 的警告才能往下一步走
                return false;
            }
        }
    }
    return true;
}
